<template>
  <div class="container">
    <div class="logo-container">
      <img src="../../../assets/images/logo-2.png" alt="" @click="goHome"/>
    </div>

    <div class="action-container">
      <h4>欢迎来到 留言管理中心 !</h4>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      
    }
  },
  computed:{
   
  },
  methods:{

    
    // 点击logo跳转到首页
    goHome(){
      this.$router.push('/home')
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo-container {
    margin-top: -12px;
    width: 200px;
    img {
      cursor: pointer;
      width: 100%;
    }
  }

  .action-container{
    h1,h2,h3,h4,h5,h6,div,span,p{
      color: #fff;
    }
  }
}
</style>